import { render } from "./SidebarNavs.vue?vue&type=template&id=7f46839c"
import script from "./SidebarNavs.vue?vue&type=script&lang=js"
export * from "./SidebarNavs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__